import { Component, OnInit, HostListener } from '@angular/core';
import { MyserviceService } from '../../provider/myservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import * as bath from '../../../../node_modules/thai-baht-text';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-print-bill',
  templateUrl: './print-bill.component.html',
  styleUrls: ['./print-bill.component.scss']
})
export class PrintBillComponent implements OnInit {
  @HostListener('window:afterprint', ['$event'])
  public afterPrintHandler(event) {
    window.close();
    window.stop();
    console.log('Printing finished or canceled.ๅๅๅ');
  }
  bill_id = '';
  customer_id = '';
  customer_name = '';
  place_description = '';
  place_address = '';
  place_id = '';
  fee_id = '';
  pay_datetime = '';
  invoice_id = '';

  total_price = '';
  discount = '';
  user = '';
  barcode = '';
  total_price_bath = '';
  fee_description1 = '';
  fee_count1 = '';
  price1 = '';
  discount1 = '';
  fee_description2 = ' ';
  fee_count2 = ' ';
  price2 = ' ';
  discount2 = '';
  fee_description3 = ' ';
  fee_count3 = ' ';
  price3 = ' ';
  discount3 = '';
  fee_description4 = ' ';
  fee_count4 = ' ';
  price4 = ' ';
  discount4 = '';
  fee_description5 = ' ';
  fee_count5 = ' ';
  price5 = ' ';
  discount5 = '';
  fee_description6 = ' ';
  fee_count6 = ' ';
  price6 = ' ';
  discount6 = '';
  fee_description7 = ' ';
  fee_count7 = ' ';
  price7 = ' ';
  discount7 = '';
  fee_description8 = ' ';
  fee_count8 = ' ';
  price8 = ' ';
  discount8 = '';
  fee_description9 = ' ';
  fee_count9 = ' ';
  price9 = ' ';
  discount9 = '';
  fee_description10 = ' ';
  fee_count10 = ' ';
  price10 = ' ';
  discount10 = '';
  fee_description11 = ' ';
  fee_count11 = ' ';
  price11 = ' ';
  discount11 = '';
  fee_description12 = ' ';
  fee_count12 = ' ';
  price12 = ' ';
  discount12 = '';
  isLoading = true;
  base64_img_muni = null;
  img_src = null;
  muni_thname = null;
  muni_amphurth = null;
  muni_tambonth = null;
  muni_thprovince = null;
  muni_postcode = null;
  muni_contact_phone = null;
  municipality = null;
  block_id = null;
  zone_name = null;
  mobile = null;
  constructor(private route: ActivatedRoute, router: Router, private service: MyserviceService, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      //debugger
      this.bill_id = params['bill_id'];
    });

    this.refresh();

    const get_Storage_invoice_multi = sessionStorage.getItem('municipality');
    this.municipality = JSON.parse(sessionStorage.getItem('municipality'));
    this.base64_img_muni = `data:image/png;base64,${JSON.parse(get_Storage_invoice_multi).icon_img}`
    this.img_src = this.sanitizer.bypassSecurityTrustUrl(this.base64_img_muni);
    const thname_muni = JSON.parse(get_Storage_invoice_multi).th_name;
    this.muni_thname = this.sanitizer.bypassSecurityTrustHtml(thname_muni);
    const thamphurth_muni = JSON.parse(get_Storage_invoice_multi).th_amphur;
    this.muni_amphurth = this.sanitizer.bypassSecurityTrustHtml(thamphurth_muni);
    const tambonth_muni = JSON.parse(get_Storage_invoice_multi).th_tambon;
    this.muni_tambonth = this.sanitizer.bypassSecurityTrustHtml(tambonth_muni);
    const provinceth_muni = JSON.parse(get_Storage_invoice_multi).th_province;
    this.muni_thprovince = this.sanitizer.bypassSecurityTrustHtml(provinceth_muni);
    const postcode_muni = JSON.parse(get_Storage_invoice_multi).postcode;
    this.muni_postcode = this.sanitizer.bypassSecurityTrustHtml(postcode_muni);
    const phone_muni = JSON.parse(get_Storage_invoice_multi).contact_phone;
    this.muni_contact_phone = this.sanitizer.bypassSecurityTrustHtml(phone_muni);

  }

  refresh() {
    var formatter = new Intl.NumberFormat('th-TH', {
      style: 'currency',
      currency: 'THB',
    });

    let month_th = '';
    this.isLoading = true;
    this.service.postData({ bill_id: this.bill_id }, "bill/get-bill-invoice").then((result: any) => {
      //debugger
      this.isLoading = false;
      console.log(result.data);
      if (!result.code) {
        if (result.data.length > 0) {

          let length_bill = 0;
          if (result.data.length <= 12) {
            length_bill = result.data.length;
          }
          else {
            length_bill = 12;
          }

          for (let x = 0; x <= length_bill - 1; x++) {

            switch (moment(result.data[x].due_date).format("MM")) {
              case '01':
                month_th = ' (มกราคม)';
                break
              case '02':
                month_th = ' (กุมภาพันธ์)';
                break
              case '03':
                month_th = ' (มีนาคม)';
                break
              case '04':
                month_th = ' (เมษายน)';
                break
              case '05':
                month_th = ' (พฤษภาคม)';
                break
              case '06':
                month_th = ' (มิถุนายน)';
                break
              case '07':
                month_th = ' (กรกฏาคม)';
                break
              case '08':
                month_th = ' (สิงหาคม)';
                break
              case '09':
                month_th = ' (กันยายน)';
                break
              case '10':
                month_th = ' (ตุลาคม)';
                break
              case '11':
                month_th = ' (พฤศจิกายน)';
                break
              case '12':
                month_th = ' (ธันวาคม)';
                break
            }

            switch (x) {
              case 0:
                result.data[x].fee_description = result.data[x].fee_description + month_th;
                this.fee_description1 = result.data[x].fee_description;
                this.fee_count1 = result.data[x].fee_type_price + ' ' + result.data[0].fee_type_unit;
                this.price1 = formatter.format(result.data[x].fee_price);
                break;
              case 1:
                result.data[x].fee_description = result.data[x].fee_description + month_th;
                this.fee_description2 = result.data[x].fee_description;
                this.fee_count2 = result.data[x].fee_type_price + ' ' + result.data[0].fee_type_unit;
                this.price2 = formatter.format(result.data[x].fee_price);

                break;
              case 2:
                result.data[x].fee_description = result.data[x].fee_description + month_th;
                this.fee_description3 = result.data[x].fee_description;
                this.fee_count3 = result.data[x].fee_type_price + ' ' + result.data[0].fee_type_unit;
                this.price3 = formatter.format(result.data[x].fee_price);

                break;
              case 3:
                result.data[x].fee_description = result.data[x].fee_description + month_th;
                this.fee_description4 = result.data[x].fee_description;
                this.fee_count4 = result.data[x].fee_type_price + ' ' + result.data[0].fee_type_unit;
                this.price4 = formatter.format(result.data[x].fee_price);

                break;
              case 4:
                result.data[x].fee_description = result.data[x].fee_description + month_th;
                this.fee_description5 = result.data[x].fee_description;
                this.fee_count5 = result.data[x].fee_type_price + ' ' + result.data[0].fee_type_unit;
                this.price5 = formatter.format(result.data[x].fee_price);

                break;
              case 5:
                result.data[x].fee_description = result.data[x].fee_description + month_th;
                this.fee_description6 = result.data[x].fee_description;
                this.fee_count6 = result.data[x].fee_type_price + ' ' + result.data[0].fee_type_unit;
                this.price6 = formatter.format(result.data[x].fee_price);

                break;
              case 6:
                result.data[x].fee_description = result.data[x].fee_description + month_th;
                this.fee_description7 = result.data[x].fee_description;
                this.fee_count7 = result.data[x].fee_type_price + ' ' + result.data[0].fee_type_unit;
                this.price7 = formatter.format(result.data[x].fee_price);

                break;
              case 7:
                result.data[x].fee_description = result.data[x].fee_description + month_th;
                this.fee_description8 = result.data[x].fee_description;
                this.fee_count8 = result.data[x].fee_type_price + ' ' + result.data[0].fee_type_unit;
                this.price8 = formatter.format(result.data[x].fee_price);

                break;
              case 8:
                result.data[x].fee_description = result.data[x].fee_description + month_th;
                this.fee_description9 = result.data[x].fee_description;
                this.fee_count9 = result.data[x].fee_type_price + ' ' + result.data[0].fee_type_unit;
                this.price9 = formatter.format(result.data[x].fee_price);

                break;
              case 9:
                result.data[x].fee_description = result.data[x].fee_description + month_th;
                this.fee_description10 = result.data[x].fee_description;
                this.fee_count10 = result.data[x].fee_type_price + ' ' + result.data[0].fee_type_unit;
                this.price10 = formatter.format(result.data[x].fee_price);

                break;
              case 10:
                result.data[x].fee_description = result.data[x].fee_description + month_th;
                this.fee_description11 = result.data[x].fee_description;
                this.fee_count11 = result.data[x].fee_type_price + ' ' + result.data[0].fee_type_unit;
                this.price11 = formatter.format(result.data[x].fee_price);

                break;
              case 11:
                result.data[x].fee_description = result.data[x].fee_description + month_th;
                this.fee_description12 = result.data[x].fee_description;
                this.fee_count12 = result.data[x].fee_type_price + ' ' + result.data[0].fee_type_unit;
                this.price12 = formatter.format(result.data[x].fee_price);
                break;
            }
          }

          this.zone_name = result.data[0].zone_name;
          this.discount = formatter.format(result.data[0].discount);
          this.customer_id = result.data[0].customer_id;
          this.customer_name = result.data[0].customer_name + ' ' + result.data[0].customer_surname;
          this.place_id = result.data[0].place_id;
          this.block_id = result.data[0].block_id;
          this.place_address = result.data[0].place_address;
          this.place_description = result.data[0].place_description;
          this.fee_id = result.data[0].fee_id;
          this.bill_id = result.data[0].bill_id;
          this.mobile = result.data[0].mobile;
          var xy = 0;
          xy = parseInt(moment(result.data[0].pay_datetime).format('YYYY'));

          if (xy < 2500) {
            xy = xy + 543;
          }

          this.pay_datetime = moment(result.data[0].pay_datetime).format("DD/MM/YYYY HH:mm:ss").replace(moment(result.data[0].pay_datetime).format('YYYY'), xy.toString());
          this.invoice_id = result.data[0].invoice_id;
          this.total_price = formatter.format(result.data[0].total_price)
          this.total_price_bath = bath(result.data[0].total_price);
          this.service.postData({ user_id: result.data[0].user_id }, "user-location/get-user-detail").then((result2: any) => {
            if (!result2.code) {
              if (result2.data.length > 0) {
                this.user = result2.data[0].user_name;
                setTimeout(() => {
                  window.print();
                }, 1000);
              } else {
                this.user = result2.data[0].user_id;
                setTimeout(() => {
                  window.print();
                }, 500);
              }
            }
            else {
              Swal.fire({
                title: result.message,
                text: '',
                type: 'error',
                showCancelButton: false,
                showConfirmButton: false,
                timer: 500
              });
            }

          })

        }

      }
      else {
        Swal.fire({
          title: result.message,
          text: '',
          type: 'error',
          showCancelButton: false,
          showConfirmButton: false,
          timer: 500
        })
      }

    })
  }
}
